import { ReactNode } from "react";
import { OAuthServiceType } from "@common/constants";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { Entity } from "@common/types/entity";
import { useAdpRunConnectionCreationMutation } from "@api/adpRun.api";
import { useViewOnlyRefusal } from "@hooks/permissions/useViewOnlyRefusal";
import { useOAuthPopup } from "@hooks/useOAuthPopup";

interface Props {
    defaultEntity?: Entity;
    onCreated?: (connection: IntegrationConnection) => void;
    children: (props: {
        connecting: boolean;
        initializeConnection: () => void;
    }) => ReactNode;
}

export const CreateAdpRunConnection = ({
    defaultEntity,
    onCreated,
    children,
}: Props) => {
    const mutation = useAdpRunConnectionCreationMutation(onCreated);
    const { refuseIfViewOnly } = useViewOnlyRefusal();
    const { open, isPopupOpen } = useOAuthPopup({
        service: OAuthServiceType.ADP_RUN,
        serviceLabel: "ADP",
        onAuthorized: ({ code }) =>
            mutation.mutate({
                authCode: code,
                defaultEntityId: defaultEntity?.id,
            }),
    });

    const initializeConnection = () => {
        if (refuseIfViewOnly()) {
            return;
        }
        open();
    };

    return children({
        connecting: isPopupOpen || mutation.isPending,
        initializeConnection,
    });
};
